import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export type DashboardWidgetContentStateKind = "loading" | "empty" | "waiting";

interface DashboardWidgetContentStateProps {
  state: DashboardWidgetContentStateKind;
  minHeight?: number;
}

/** Centered non-error state used while a dashboard card is loading or has no records to show. */
export function DashboardWidgetContentState({
  state,
  minHeight = 96,
}: DashboardWidgetContentStateProps) {
  const isLoading = state === "loading";
  const isWaiting = state === "waiting";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        minHeight,
        textAlign: "center",
      }}
    >
      {isLoading ? (
        <CircularProgress size={20} />
      ) : (
        <InfoOutlinedIcon sx={{ color: "text.secondary", fontSize: "1.25rem" }} />
      )}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {isLoading
            ? "Loading data"
            : isWaiting
              ? "Select filters to load data"
              : "No data available"}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {isLoading
            ? "Retrieving the latest dashboard data."
            : isWaiting
              ? "Choose an area and date range, then apply the filters."
              : "There is nothing to show for the current view."}
        </Typography>
      </Box>
    </Box>
  );
}
